var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TableOrder"},[_vm._m(0),_c('div',[_c('phoneTable')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-title"},[_c('div',{staticClass:"icon_title"},[_c('div',[_c('img',{staticClass:"case-title_icon",attrs:{"src":require("@/assets/images/imgAll/icon_ddtj_.png"),"alt":""}})]),_c('div',{staticClass:"case-title_max"},[_vm._v("门店商家-交易排行")])])])
}]

export { render, staticRenderFns }